
import React, { useMemo } from 'react';
import { Button } from 'antd'
import { COLOR, FONT } from '../constants';
import styled from 'styled-components'
import { useSelector } from 'react-redux';


const StyledButton = styled(Button)`
  &:hover {
    background-color: ${COLOR.content} !important;
    border: 3px solid #000000;
    box-shadow: 6px 7px 0px #000000;
    border-radius: 8px;
  }
`


const MintButton = ({
  onClick
}) => {
  const solana_config = useSelector(state => state.app.solana_config)
  return (
    <StyledButton
      id="mint-button"
      onClick={onClick}
      style={{ ...FONT.button, backgroundColor: COLOR.textSecondary, color: COLOR.secondary, height: 48, borderRadius: 8 }}
    >
      {'>>>  Start Minting !  <<<'}
    </StyledButton>
  )
}

export default MintButton;